import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/data/catalog";

let cache = null;
let pending = null;
const FALLBACK = { name: "InfinityFeedback SRL", status: "", address: "", vat_id: "", reg_no: "", email: "", dpo_email: "" };

export const useCompany = () => {
  const [company, setCompany] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) return;
    pending = pending || axios.get(`${API}/public/company`).then((r) => { cache = r.data; return cache; }).catch(() => FALLBACK);
    pending.then(setCompany);
  }, []);
  return company;
};

export const companyLine = (c, t) => [
  `${c.name}${c.status ? ` (${c.status})` : ""}`,
  c.address && `${t("company.address")}: ${c.address}`,
  `${t("company.vat")}: ${c.vat_id || t("company.vatPending")}`,
  c.reg_no && `${t("company.reg")}: ${c.reg_no}`,
].filter(Boolean);
